module.exports = __webpack_public_path__ + "img/8.61b78f53.jpg";